// @ts-nocheck — composed component; types added when touched again later
import React from "react";

/* composed/ScenariosBar.tsx — scenario chip selector (Phase 4 sub-step 7).
   Extracted from the inline `head__scenari` block in src/legacy/app.tsx.
   The scenarios EDITOR (where you change EOM target / pros / cons /
   risks per variant) lives inside InputsPanel (sub-step 6), not here.
   This component is just the three-chip selector.

   Currently consumes the legacy Segmented primitive via window.V2 +
   window globals (auto-globaled by legacy primitives.tsx). When sub-step
   1 ports the header, we'll replace with the v2 Tab/Segmented primitive
   from src/components/ui/. Today this is a pure structural relocation —
   the JSX matches the legacy markup byte-for-byte.

   Props
     lang             — "it" | "en"
     activeScenario   — "base" | "optimistic" | "pessimistic"
     onChange(scen)   — handler; legacy app.tsx passes `setScenario`
*/

export default function ScenariosBar({ lang, activeScenario, onChange }) {
  const Segmented = (typeof window !== "undefined" && (window as any).Segmented) || null;
  if (!Segmented) return null;

  return (
    <div className="head__scenari">
      <Segmented
        size="sm"
        ariaLabel={lang === "it" ? "Scenario" : "Scenario"}
        title={
          lang === "it"
            ? "Pessimistico / Base / Ottimistico — riscala i target futuri"
            : "Pessimistic / Base / Optimistic — rescales future targets"
        }
        value={activeScenario}
        options={[
          { id: "pessimistic", label: "😟", accent: "danger",  title: lang === "it" ? "Pessimistico" : "Pessimistic" },
          { id: "base",        label: "📊", accent: "accent",  title: "Base" },
          { id: "optimistic",  label: "🚀", accent: "success", title: lang === "it" ? "Ottimistico" : "Optimistic" },
        ]}
        onChange={onChange}
      />
      <span className="head__scenari-label">
        {lang === "it" ? "seleziona scenario" : "select scenario"}
      </span>
    </div>
  );
}
